<script setup>
defineProps({
  checks: {
    type: Object,
    required: true
  }
})
</script>

<template>
  <ul class="mt-3 flex flex-col gap-1.5 text-sm">
    <li class="flex items-center gap-2" :class="checks.minLength ? 'text-success' : 'text-error'">
      <span>{{ checks.minLength ? '✓' : '✕' }}</span>
      <span>Minimum 8 letters</span>
    </li>
    <li class="flex items-center gap-2" :class="checks.hasNumber ? 'text-success' : 'text-error'">
      <span>{{ checks.hasNumber ? '✓' : '✕' }}</span>
      <span>At least one number</span>
    </li>
    <li class="flex items-center gap-2" :class="checks.hasSpecial ? 'text-success' : 'text-error'">
      <span>{{ checks.hasSpecial ? '✓' : '✕' }}</span>
      <span>At least one special character</span>
    </li>
  </ul>
</template>
